import httpClient from 'api/httpClient';
import publicHttpClient from 'api/publicHttpClient';
import { Lead } from 'models/Lead';

type RequestAccess = Pick<
  Lead,
  | 'firstName'
  | 'lastName'
  | 'email'
  | 'contactNumber'
  | 'company'
  | 'linkedinProfile'
  | 'natureOfInterest'
  | 'howDiscoverListing'
>;

export type ExtendedRequestAccess = RequestAccess & {
  password: string;
  recaptchaResponseToken: string;
};

function requestPrivateListingAccess(
  listingId: string,
  data: ExtendedRequestAccess,
) {
  return publicHttpClient.post(
    `leads/listings/${listingId}/new-private-viewer`,
    data,
  );
}

function requestPrivateListingAccessLoggedIn(
  listingId: string,
  data: RequestAccess,
) {
  return httpClient.post(
    `leads/listings/${listingId}/exist-private-viewer`,
    data,
  );
}

export default {
  requestPrivateListingAccess,
  requestPrivateListingAccessLoggedIn,
};
